<template>
    <DxTabPanel :data-source="tabs" :animation-enabled="true" :loop="false" :defer-rendering="false" height="100%">
        <template #item="{ data }">
            <component :is="data.component" :employee-id="employeeId" :employee-row="employeeRow" :key="employeeId" />
        </template>
    </DxTabPanel>

</template>

<script lang="ts">
import { DxTabPanel } from 'devextreme-vue/tab-panel'
import GeneralTab from './GeneralTab.vue'
import DateSuplimentare from './DateSuplimentare.vue';

export default {
    components: { DxTabPanel, GeneralTab, DateSuplimentare },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    data() {
        return {
            tabs: [
                // folosește referința, nu stringul
                { title: 'Date generale', component: GeneralTab },
                { title: 'Date suplimentare', component: DateSuplimentare}
            ]
        }
    }
}
</script>
<style>
.dx-tabpanel .dx-tabs-wrapper .dx-tab:nth-child(2) {
  min-width: 165px !important; 
}

</style>